import styled from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';
import Wave from 'products/nomad_insurance/assets/img/waves/wave.svg';
import WaveMobile from 'products/nomad_insurance/assets/img/waves/wave-mobile.svg';
import SideNav from './components/SideNav';
import DropdownNav from './components/DropdownNav';
import { policyColor } from './policyColors';

export const GAP = 32;

export const Wrapper = styled.div`
  --gap: ${GAP}px;

  /* measured */
  --header-height-measure: 0;

  /* computed */
  --header-height: calc(var(--header-height-measure) * 1px);

  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  background-color: ${th('colors.white')};
  color: ${th('colors.black')};
  min-height: 100svh;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 1344px;
  margin: 0 auto;
  padding: 0 12px;

  @media ${sizes.tabletPortrait} {
    padding: 0 24px;
  }

  @media ${sizes.tabletLandscape} {
    padding: 0 32px;
  }

  @media ${sizes.desktop} {
    padding: 0 64px;
  }
`;

export const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const StickyHeader = styled(Sticky)`
  background-color: ${th('colors.white')};
  z-index: 2;

  &::after {
    content: ' ';
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    height: 32px;
    background: linear-gradient(${th('colors.white')}, transparent);
  }

  @media ${sizes.desktop} {
    background-color: transparent;
    &::after {
      content: none;
    }
  }
`;

export const Header = styled.div`
  padding-top: var(--nav-height);
  background-color: ${policyColor('main')};
`;

export const HeaderWave = styled.div`
  background-color: ${policyColor('main')};
  -webkit-mask: url(${WaveMobile}) bottom / 100% no-repeat;
  mask: url(${WaveMobile}) bottom / 100% no-repeat;
  height: 32px;
  margin-top: -1px;
  margin-left: -2px;

  @media ${sizes.tabletPortrait} {
    -webkit-mask-image: url(${Wave});
    mask-image: url(${Wave});
  }

  @media ${sizes.desktop} {
    height: 64px;
  }
`;

export const QuestionsContent = styled.div`
  display: grid;

  @media ${sizes.desktop} {
    grid-template-columns: 300px 1fr;
    align-items: start;
    gap: 32px;

    & > ${Sticky} {
      top: var(--header-height);
    }
  }
`;

export const TitleHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 32px;
  padding-top: 12px;
  z-index: 1;

  & > * {
    display: block;
  }

  @media ${sizes.desktop} {
    padding-top: 32px;
  }

  > h1 {
    color: ${th('colors.white')};
    letter-spacing: 0;

    @media ${sizes.mobileMedium} {
      font-size: 29px;
    }

    @media ${sizes.tabletPortrait} {
      font-size: 40px;
    }
  }
`;

export const StyledSideNav = styled(SideNav)`
  display: none;
  @media ${sizes.desktop} {
    display: flex;
  }
`;

export const StyledDropdownNav = styled(DropdownNav)`
  display: block;
  padding-top: 12px;
  padding-bottom: 12px;

  @media ${sizes.desktop} {
    display: none;
  }
`;

export const DownloadLink = styled.a`
  display: none;
  color: ${th('colors.white')};

  @media ${sizes.extraLargeDesktop} {
    display: block;
  }
`;
